export const PlanPage = () => {
    return (
        <div className="pagecontent">
            <h1>План готовки</h1>
        </div>
    )
}